import { useWhatIfPositions } from "@iliotech/data-wire/src/stores";
import { observer } from "mobx-react-lite";
import { WhatIfResultsCellProps } from "../WhatIfResultsColumn";

export const SegmentsCell = ({ dataItem }: WhatIfResultsCellProps) => {
  return <b>{dataItem?.name}</b>;
};

export default SegmentsCell;
